import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLang = i18n.language.startsWith('fr') ? 'en' : 'fr';
    i18n.changeLanguage(nextLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1 p-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors text-sm font-semibold text-slate-700 dark:text-slate-300"
      aria-label="Toggle language"
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase">{i18n.language.substring(0, 2)}</span>
    </button>
  );
};

export default LanguageSelector;
